import { useAutocompleteContext } from './context'
import { AutocompleteItemApi, AutocompleteResult } from './types'

export function useAutocompleteItem(result: AutocompleteResult): AutocompleteItemApi {
  const register = useAutocompleteContext()
  return register(result)
}
